import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedLayout from '../wrappers/layout-wrapper';
import MatchingLayout from '../wrappers/matching-layout-wrapper';
import Conversation from '../../pages/messages/conversation';
import Screen from '../../pages/trip-request/screen';
import TripMatching from '../../pages/trip-matching/match';
import ConfirmMatch from '../../pages/trip-matching/confirm-match';

const useFullPageRoutes = () => (
  <Route element={<ProtectedLayout hideNav />}>
    {/* Trip Match Routes for Messaging */}
    <Route path="trip-matches/:tripMatchId/messages/:conversationId">
      <Route index element={<Conversation />} />
    </Route>

    <Route path="trip-requests/:tripRequestId">
      <Route path="screen" element={<Screen />} />
      <Route path="messages/:conversationId">
        <Route index element={<Conversation />} />
      </Route>

      {/* Trip Request Match Form */}
      <Route element={<MatchingLayout />}>
        <Route path="match" element={<TripMatching />} />
        <Route path="confirm-match" element={<ConfirmMatch />} />
      </Route>
    </Route>

  </Route>
);

export default useFullPageRoutes;
